import HttpClient from "../helpers/HttpClient"
import { isError } from "../helpers/Error"
import PriceLevel, { PriceLevelDto } from "./PriceLevel"

class PriceLevelService {
    static httpClient = new HttpClient<PriceLevel, PriceLevelDto>(PriceLevel)

    static async getAll(): Promise<PriceLevel[]> {
        const res = await this.httpClient.get("/price-levels")
        if (isError(res)) {
            throw new Error(res.message)
        }
        return res as PriceLevel[]
    }

    static async create(payload:{name:string}): Promise<PriceLevel> {
        const res = await this.httpClient.post("/price-levels",payload)
        if (isError(res)) {
            throw new Error(res.message)
        }
        return res as PriceLevel
    }

    static async get(id:string): Promise<PriceLevel> {
        const res = await this.httpClient.get(`/price-levels/${id}`)
        if (isError(res)) {
            throw new Error(res.message)
        }
        return res as PriceLevel
    }

    static async delete(id:string): Promise<PriceLevel> {
        const res = await this.httpClient.delete(`/price-levels/${id}`)
        if (isError(res)) {
            throw new Error(res.message)
        }
        return res as PriceLevel
    }

    static async update(priceLevelId:string,payload:{name:string}): Promise<PriceLevel> {
        const res = await this.httpClient.put(`/price-levels/${priceLevelId}`,payload)
        if (isError(res)) {
            throw new Error(res.message)
        }
        return res as PriceLevel
    }
}

export default PriceLevelService


// WEBPACK FOOTER //
// ./src/state/price-level/PriceLevelService.ts